
/*!
 * @name JS Handler: helpers - ES Module
 * @desc Provides helpers (workbench compatable)
 * @version v1.0.0
 * @website undefined
 * @license ISC
 * @copyright (c) 2025
 * @author fw@maa
 */
function helpersPart(_parent, _CONTEXT) {

  let _HELPERS_LIST = {};

  let _LOG_VERBOSITY = {};
  _LOG_VERBOSITY.ommit = [];
  _LOG_VERBOSITY.mode = [];
  if (typeof window === 'object')
  {
    if (!('_dsb_log_verbosity_ommit' in window))
    {
      window._dsb_log_verbosity_ommit = [];
    }
    _LOG_VERBOSITY.ommit = window._dsb_log_verbosity_ommit;
  }

  _HELPERS_LIST.tools = {};
  _HELPERS_LIST.tools._skip_log = true;
  _HELPERS_LIST.tools.setLoggingMode = function (mode)
  {
    if (!Array.isArray(mode))
    {
      let _mode = mode;
      mode = [];
      mode.push(_mode);
    }
    _LOG_VERBOSITY.mode = mode;
  };
  _HELPERS_LIST.tools.logging = function (type, source, message, data = '')
  {
    if ('mode' in _LOG_VERBOSITY)
    {
      for (let amode of _LOG_VERBOSITY.mode)
      {
        if (amode.startsWith('!') && amode == '!' + type)
        {
          return;
        } else
        if (amode !== type)
        {
          return;
        }
      }
    }
    let _message = ' - ' + message;
    let prefix = source;
    if ('context_name' in _CONTEXT)
    {
      prefix = _CONTEXT.context_name + '::' + prefix;
    }
    _message = prefix + _message;

    if ('ommit' in _LOG_VERBOSITY)
    {
      if (_LOG_VERBOSITY.ommit.indexOf(type + '/' + prefix) > -1)
      {
        return;
      }
      if (_LOG_VERBOSITY.ommit.indexOf(type) > -1)
      {
        return;
      }
    }

    switch (type) {

      case "debug":
        console.debug(_message, data);
        break;
      case "warning":
        console.warn(_message, data);
        break;
      case "info":
        console.info(_message, data);
        break;
      case "error":
        console.error(_message, data);
        break;
      default:
        console.log(_message, data);}


  };
  _HELPERS_LIST.tools.delaySecAsync = async function (sec) {
    return new Promise(function (res)
    {
      _this._log('debug', 'Waiting for ' + sec + ' seconds.', sec * 1000);
      setTimeout(res, sec * 1000);
    });
  };
  _HELPERS_LIST.tools.sayHello = function (message) {
    _HELPERS_LIST._log('debug', 'sayHello', message);
  };
  _HELPERS_LIST.tools.getTrueForm = function (item, form = '')
  {
    if (typeof item === 'string')
    {
      try
      {
        item = JSON.parse(item);
      }
      catch (ex)
      {
        try
        {
          item = JSON.parse(atob(item));
        }
        catch (ex)
        {
          //ok
        }
      }
    }
    if (typeof form === 'string')
    {
      if (form.length > 0)
      {
        switch (form) {

          case "object":
            if (!typeof item === 'object')
            {
              item = { item };
            }
            break;
          case "array":
            if (!Array.isArray(item))
            {
              item = [item];
            }
            break;}

      }
    }
    return item;
  };
  _HELPERS_LIST.html = {};
  _HELPERS_LIST.html.spinner = function ()
  {
    return `<div>
              <svg class="spinner" width="34px" height="34px" viewBox="0 0 66 66" xmlns="http://www.w3c.org/2000/svg"><circle class="path" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
          </div>`;
  };

  let _LOG = function (type, source, message, data = '')
  {
    source = '(part-helpers)' + source;
    _parent.run('tools', 'logging', [type, source, message, data]);
  };

  _parent.has = function (helper, method, throw_mode = false) {
    try
    {
      if (helper.length > 0 && method.length > 0 && !method.startsWith('_'))
      {
        if (helper in _HELPERS_LIST && typeof _HELPERS_LIST[helper] === 'object' && method in _HELPERS_LIST[helper] && typeof _HELPERS_LIST[helper][method] === 'function')
        {
          return true;
        }
      }
    }
    catch (ex)
    {
      if (throw_mode || helper === 'tools')
      {
        throw ex;
      } else

      {
        _LOG('error', 'has', 'Has failed!', { 'ex': ex, 'helper': helper, 'method': method, 'throw_mode': throw_mode });
      }
    }
    return false;
  };

  _parent.list = function ()
  {
    return Object.keys(_HELPERS_LIST);
  };

  _parent.run = function (helper, method, params, _default = null, error_mode = 'log')
  {
    try
    {
      if (_parent.has(helper, method))
      {
        if (!Array.isArray(params))
        {
          params = [params];
        }
        if (helper !== 'tools')
        {
          _LOG('debug', 'run', 'Found ' + helper + '.' + method + '()', { 'helper': helper, 'method': method, 'params': params });
        }
        return _HELPERS_LIST[helper][method](...params);
      } else

      {
        if (helper !== 'tools')
        {
          _LOG('warning', 'run', 'Cannot find ' + helper + '.' + method + '()!', { 'helper': helper, 'method': method, 'params': params });
        }
        if (typeof _default === 'function')
        {
          return _default();
        } else

        {
          return _default;
        }
      }
    }
    catch (ex)
    {
      if (error_mode == 'throw' || helper === 'tools')
      {
        throw ex;
      } else
      if (error_mode !== 'silent')
      {
        _LOG('error', 'run', 'Run failed!', { 'ex': ex, 'helper': helper, 'method': method, 'params': params, 'error_mode': error_mode });
      }
    }
  };

  _parent.add = function (helper, method, this_function)
  {
    if (!(typeof _HELPERS_LIST === 'object'))
    {
      _HELPERS_LIST = {};
    }

    if (typeof helper === 'string' && helper.length > 0 && typeof method === 'string' && method.length > 0 && typeof this_function === 'function')
    {
      try
      {
        _LOG('debug', 'add', 'Adding helper[' + helper + '][' + method + ']()...');
        if (!(helper in _HELPERS_LIST))
        {
          _HELPERS_LIST[helper] = {};
        }
        _HELPERS_LIST[helper][method] = this_function;
      }
      catch (ex)
      {
        _LOG('error', 'add', 'Adding helper ' + helper + '.' + method + ' failed!', ex);
      }
    } else

    {
      _LOG('warning', 'add', 'Mallformed! helper="' + helper + '",method="' + method + '" or supplied function isnt a function.');
    }
    return false;
  };

  _parent.runUrlAsync = async function (url, _default = null, error_mode = 'log')
  {
    try
    {
      if (typeof url === 'string')
      {
        let split_point = url.indexOf('//');
        if (split_point > 0)
        {
          let path = url.substring(split_point + 2);
          split_point = path.indexOf('/');
          if (split_point > 0)
          {
            let target = path.substring(0, split_point);
            let params = path.substring(split_point + 1);
            params = params.replaceAll("'", '"');
            target = target.split('.');
            if (target.length == 2)
            {
              return await _parent.run(target[0], target[1], _HELPERS_LIST.tools.getTrueForm(params, 'array'), _default, error_mode);
            } else

            {
              throw 'Missing helper name or method format: "helper_name.method"';
            }
          } else

          {
            throw 'Cannot find / in path="' + path + '"';
          }
        } else

        {
          throw 'Cannot find // in url="' + url + '"';
        }
      } else

      {
        throw "url is not a string";
      }
    }
    catch (ex)
    {
      if (error_mode == 'throw')
      {
        throw ex;
      } else
      if (error_mode !== 'silent')
      {
        _LOG('error', 'runUrlAsync', 'runUrlAsync failed!', { 'ex': ex, 'url': url, '_default': _default, 'error_mode': error_mode });
      }
    }
    return _default;
  };
}

function filtersPart(_parent, _CONTEXT) {

  let _FILTERS = {};
  _parent.has = function (filter)
  {
    if (typeof filter === 'string' && filter.length > 0 && filter in _FILTERS && typeof _FILTERS[filter] === 'function')
    {
      return true;
    }
    return false;
  };

  _parent.apply = function (filter, params)
  {
    if (_parent.has(filter))
    {
      return _FILTERS[filter](...params);
    } else

    {
      return params;
    }
  };

  _parent.add = function (filter, filter_function)
  {
    if (typeof filter_function === 'function')
    {
      _FILTERS[filter] = filter_function;
    } else

    {
      throw 'Not a function';
    }
  };
}

function hooksPart(_parent, _CONTEXT) {

  if (!(typeof _parent === 'object'))
  {
    throw 'part-hooks::_parent is not an object';
  }

  for (let require_method of ['has', 'run', 'add'])
  {
    if (require_method in _parent)
    {
      throw 'part-hooks::_parent.' + require_method + ' already exists';
    }
  }

  let _HOOKS = {};

  _parent.has = function (hook)
  {
    if (hook in _HOOKS && typeof _HOOKS[hook] === 'function')
    {
      return true;
    }
    return false;
  };

  _parent.run = function (hook, params)
  {
    if (_parent.has(hook))
    {
      _HOOKS[hook](...params);
    }
  };

  _parent.add = function (hook, hook_function)
  {
    if (typeof hook === 'string' && hook.length > 0 && typeof hook_function === 'function')
    {
      _HOOKS[hook] = hook_function;
    } else

    {
      throw 'Not a function';
    }
  };

}

function toolsPart(_parent, _CONTEXT) {


  _parent._createUUID = function ()
  {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };

}

function fetchHelper(_HELPERS, _CONTEXT = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-fetch.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let FETCH_CONNECTIONS = {};
    let FETCH = {};

    FETCH.addConnectionAsync = async function (alias, url, options = false, auth = false)
    {

      if (!(alias in FETCH_CONNECTIONS))
      {
        if (!(typeof options === 'object'))
        {
          try
          {
            options = JSON.parse(JSON.stringify(options));
          }
          catch (ex)
          {
            _LOG('warning', 'addConnection', 'Alias: ' + alias + ' options doesnt seem to be JSON');
          }

          if (!(typeof options === 'object') || object === null)
          {
            options = {};
          }
        }
        if (!(typeof auth === 'object'))
        {
          try
          {
            auth = JSON.parse(JSON.stringify(auth));
          }
          catch (ex)
          {
            _LOG('warning', 'addConnection', 'Alias: ' + alias + ' auth doesnt seem to be JSON');
          }
          if (!(typeof auth === 'object') || auth === null)
          {
            auth = {};
          }
        }

        if (!('header' in options))
        {
          options.header = {};
        }

        let user_object = false;
        if ('method' in auth && 'target' in auth)
        {
          switch (auth.method) {

            case "variable":
              try
              {
                if (typeof _target === 'string')
                {
                  let _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : null;
                  if (_global != null)
                  {
                    user_object = this._getDataValue(_global, _target, null);
                  } else

                  {
                    throw 'auth.method[variable].target cannot find a global (no window or global var)!';
                  }
                } else
                if (typeof _target === 'object')
                {
                  user_object = _target;
                }

                if (typeof user_object === 'object' && user_object != null)
                {
                  if (!('isConnectionTokenValid' in user_object) || typeof user_object.isConnectionTokenValid !== 'function')
                  {
                    throw "Missing isConnectionTokenValid in user_object";
                  }
                  if (!('getConnectionToken' in user_object) || typeof user_object.getConnectionToken !== 'function')
                  {
                    throw "Missing getConnectionToken in user_object";
                  }
                }
              }
              catch (ex)
              {
                throw { code: '400', message: "Error processing auth.method[variable]: " + ex, _target };
              }
              break;
            case "cookie":
              user_object = {};
              user_object.isConnectionTokenValid = function () {return true;};
              user_object.getConnectionToken = function () {return _this._getCookie(auth.target);};
              break;
            case "target":
              user_object = {};
              user_object.isConnectionTokenValid = function () {return true;};
              user_object.getConnectionToken = function () {return auth.target;};
              break;
            default:
              __LOG('debug', 'connections[' + alias + '].fetch', 'Unknown auth.method', auth.hook);
              break;}

        }

        url = url.endsWith('/') ? url : url + '/';

        FETCH_CONNECTIONS[alias] = {};
        FETCH_CONNECTIONS[alias].dataset = {};
        FETCH_CONNECTIONS[alias].fetch = async function (query, headers)
        {
          let result = { code: '500', message: 'Unknown error' };
          try
          {
            for (let aheaders in headers)
            {
              options.header[aheaders] = headers[aheaders];
            }

            if (user_object && typeof user_object === 'object')
            {
              let is_logged_in = false;
              if ('isConnectionTokenValid' in user_object)
              {
                if (await user_object.isConnectionTokenValid(alias, require_role))
                {
                  is_logged_in = true;
                  if ('getConnectionToken' in user_object && typeof user_object.getConnectionToken === 'function')
                  {
                    user_token = user_object.getConnectionToken(alias);
                  }
                }
              }
              if (!is_logged_in)
              {
                throw { code: '401', message: 'You need to be a ' + (typeof require_role === 'string' ? require_role : 'user') + ' to access this resource' };
              }
            }

            if ('login_only' in auth && auth.login_only == 'yes')
            {
              if (user_token && typeof user_token === 'string' && user_token.length > 0)
              {
                if ('Authorization' in _options)
                {
                  options['Authorization'].replace('{user_token}', user_token);
                } else

                {
                  url.replace('{user_token}', user_token);
                }
              } else

              {
                throw { code: '401', message: 'You need to be a ' + (typeof require_role === 'string' ? require_role : 'user') + ' to access this resource (token missing)' };
              }
            }

            __LOG('debug', 'connections[' + alias + '].fetch', 'Fetching', url + query, options);
            result = await fetch(url + query, options);
            if ('login_only' in auth && auth.login_only == 'yes' && 'try_login_on_401' in auth && auth.try_login_on_401 == 'yes' && result.code == 401)
            {
              __LOG('debug', 'get', '1st try 401-ed, trying again...');
              if (user_object && typeof user_object === 'object')
              {
                if ('renewSession' in user_object)
                {
                  await user_object.renewSession();
                }
              }
              return _FETCH_CONNECTIONS[alias].fetch(query, headers);
            }
          }
          catch (ex)
          {
            if (typeof ex === 'object' && 'code' in ex)
            {
              result = ex;
            } else

            {
              result = { 'code': 500, 'message': ex };
            }
          }
          return result;
        };

        _LOG('debug', 'addConnection', 'Alias: ' + alias + ' connection added.');
        return true;
      } else

      {
        _LOG('debug', 'addConnection', 'Alias: ' + alias + ' connection already exists. Skipping');
      }
      return false;
    };

    FETCH.getAsync = async function (url, options = {}, allow_offline = false, retry = true)
    {
      if (!(typeof options === 'object'))
      {
        options = {};
      }
      options.method = 'GET';
      return FETCH._fetch(url, options, allow_offline, retry);
    };

    FETCH.postAsync = async function (url, data, options = {}, allow_offline = false, retry = true)
    {
      if (!data)
      {
        throw { 'code': 400, 'message': 'missing data' };
      }
      if (!(typeof options === 'object'))
      {
        options = {};
      }
      options.method = 'POST';
      options.body = data;
      return FETCH._fetch(url, options, allow_offline, retry);
    };

    FETCH._fetch = async function (urlString, options = {}, allow_offline = false, retry = true)
    {
      let result = {};
      result.code = 500;
      result.status = 'fetch-failed';
      try
      {
        let is_offline = await _HELPERS.run('networking', 'isOfflineAsync', [], false);
        if (is_offline)
        {
          if (!allow_offline)
          {
            throw { code: '503', message: 'Offline without allow_offline', allow_offline };
          }
        }
        let url = new URL(urlString);
        let hash = false;
        let underscore_options = {};
        underscore_options.check_envalope = true;
        if ('hash' in url)
        {
          if (_HELPERS.has('process', 'hash'))
          {
            hash = _HELPERS.run('process', 'hash', [url.hash, {}, 'object']);
            if ('__' in hash)
            {
              for (let an_ in hash.__)
              {
                underscore_options[an_] = hash.__[an_];
              }
              delete hash.__;
            }
          } else

          {
            _LOG('warning', 'fetch', 'Helper helper(process,hash) required! No hash based opperations will be preformed.');
          }
        }

        if (!(typeof options === 'object'))
        {
          options = {};
        }

        if (!('method' in options))
        {
          options.method = 'GET';
        }

        if (options.method === 'POST')
        {
          if ('body' in options && typeof options.body === 'object')
          {
            options.data = JSON.stringify(options.body);
          }
        }

        _LOG('debug', '_fetch', 'Fetching [' + options.method + ']: ' + url);


        let fetch_response = {};
        if (url.protocol.startsWith('http:') || url.protocol.startsWith('https:'))
        {
          fetch_response = await fetch(url.href, options);
        } else

        {
          let connection_alias = url.protocol.replace(':', '');
          if (connection_alias in FETCH_CONNECTIONS)
          {
            fetch_response = await FETCH_CONNECTIONS[connection_alias].fetch(query, options);
          } else

          {
            throw 'Unknown connection "' + connection_alias + '"';
          }
        }

        if (typeof fetch_response === 'object' && 'text' in fetch_response)
        {
          if ('status' in fetch_response)
          {
            result.code = fetch_response.status;
            if (result.code == 200)
            {
              result.state = 'success';
            }
          }
          if ('statusText' in fetch_response && fetch_response.statusText.length > 0)
          {
            result.state = fetch_response.statusText;
            result.message = fetch_response.statusText;
          }
          result.data = await fetch_response.text();
          try
          {
            result.data = JSON.parse(result.data);
            if (underscore_options.check_envalope)
            {
              if ('code' in result.data && 'state' in result.data && 'data' in result.data)
              {
                result = result.data;
              } else

              {
                _LOG('debug', 'fetch', 'No envalope detected.', { 'data': result.data });
              }
            }
          }
          catch (ex)
          {
            //Ok probably just text
          }

          if (typeof hash === 'object' && Object.keys(hash).length > 0)
          {
            if (_HELPERS.has('process', 'data'))
            {
              let processDataMode = 'ommit';
              _LOG('debug', 'fetch', 'Filtering results for ' + urlString + '', { 'data': result.data, 'hash': hash, 'processDataMode': processDataMode });
              if (typeof result.data === 'object')
              {
                result.data = _HELPERS.run('process', 'data', [result.data, hash, processDataMode]);
              }
            } else

            {
              _LOG('warning', 'fetch', 'Helper helper(process,data) required! Returning data unaffected.');
            }
          }

          /**if(!Array.isArray(result.data))
            {
              let _fetch_data=[];
              _fetch_data.push(result.data);
              result.data=_fetch_data;
            }
            */

        }

        _LOG('debug', '_fetch', 'Found ' + url, { 'hash': hash, 'result': result, 'fetch_response': fetch_response });
      }
      catch (ex)
      {
        result.code = 500;
        result.status = 'error';
        if (typeof ex === 'object')
        {
          if ('code' in ex)
          {
            result.code = ex.code;
          }
          if ('message' in ex)
          {
            result.message = ex.message;
          }
          if ('data' in ex)
          {
            result.data = ex.data;
          }
        } else

        {
          result.message = ex;
        }
      }
      return result;
    };

    _HELPERS.add('fetch', 'get', FETCH.getAsync);
    _HELPERS.add('fetch', 'post', FETCH.postAsync);
    _HELPERS.add('fetch', 'getAsync', FETCH.getAsync);
    _HELPERS.add('fetch', 'postAsync', FETCH.postAsync);
    _HELPERS.add('fetch', 'addConnection', FETCH.addConnectionAsync);
  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

function processHelper(_HELPERS, _FILTERS = {}) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-process.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let PROCESS = {};
    let MATCH = {};
    PROCESS.query = function (query, params = {}, mode = true)
    {
      const getQueryParams = function (query, _params = {}, mode = false)
      {
        let params = {};
        if (typeof query === 'string')
        {
          if (query.includes('?'))
          {
            query = query.substring(query.indexOf('?') + 1);
          }
          query = PROCESS.moustache(query);
          new URLSearchParams(query).forEach((value, key) => {
            let decodedKey = decodeURIComponent(key);
            let decodedValue = decodeURIComponent(value);

            switch (decodedValue) {

              case "{{today}}":
                decodedValue = PROCESS.format_date('now', 'Y-m-d');
                break;
              case "{{yesterday}}":
                decodedValue = PROCESS.format_date('yesterday', 'Y-m-d');
                break;
              case "{{yesterday_timestamp}}":
                decodedValue = PROCESS.format_date('yesterday', 'timestamp_y-m-d');
                break;
              case "{{today_timestamp}}":
                decodedValue = PROCESS.format_date('now', 'timestamp_y-m-d');
                break;
              case "{{tomorrow}}":
                decodedValue = PROCESS.format_date('tomorrow', 'Y-m-d');
                break;}


            // This key is part of an array
            if (decodedKey.endsWith("[]")) {
              decodedKey = decodedKey.replace("[]", "");
              params[decodedKey] || (params[decodedKey] = []);
              params[decodedKey].push(decodedValue);
              // Just a regular parameter
            } else {
              params[decodedKey] = decodedValue;
            }
          });
          if (mode == 'diff')
          {
            let diff = {};
            for (let _param_key in _params)
            {
              if (_param_key in params)
              {
                if (params[_param_key] == _params[_param_key])
                {
                  if (!('same' in diff))
                  {
                    diff.same = {};
                  }
                  diff.same[_param_key] = params[_param_key];
                } else

                {
                  if (!('changed' in diff))
                  {
                    diff.changed = {};
                  }
                  diff.changed[_param_key] = {};
                  diff.changed[_param_key].from = params[_param_key];
                  diff.changed[_param_key].to = _params[_param_key];
                }
              } else

              {
                if (!('missing' in diff))
                {
                  diff.missing = {};
                }
                diff.missing[_param_key] = _params[_param_key];
              }
            }
            return diff;
          } else

          {
            // Update with _params
            for (let _param_key in _params)
            {
              params[_param_key] = _params[_param_key];
            }

            if (mode == 'cleanse')
            {
              // Remove missing
              for (let param_key in params)
              {
                if (!(param_key in _params))
                {
                  delete params[param_key];
                }
              }
            }
          }
        }
        return params;
      };
      if (mode == 'diff')
      {
        if (typeof params !== 'object')
        {
          params = getQueryParams(params);
        }
        return getQueryParams(query, params, mode);
      } else
      if (mode == 'object')
      {
        return getQueryParams(query, params, mode);
      } else

      {
        let thisQueryString = [];
        let url_params = getQueryParams(query, params, mode);
        for (let aUrl_paramsKey in url_params)
        {
          if (Array.isArray(url_params[aUrl_paramsKey]))
          {
            for (let i = 0; i < url_params[aUrl_paramsKey].length; i++)
            {
              thisQueryString.push(aUrl_paramsKey + '[]=' + url_params[aUrl_paramsKey][i]);
            }
          } else

          {
            thisQueryString.push(aUrl_paramsKey + '=' + url_params[aUrl_paramsKey]);
          }
        }return thisQueryString.join('&');
        //let url_params = new URLSearchParams(getQueryParams(query,params,mode));
        //return url_params.toString();
      }
    };

    PROCESS.hash = function (target, data = {}, mode = true)
    {
      let result = '';
      let function___processHash = function (this_url, data = {}, mode = true)
      {
        if (!this_url.startsWith('#'))
        {
          this_url = '#' + this_url;
        }
        let hash = decodeURIComponent(this_url);
        if (hash.length > 0 && hash.includes('#'))
        {
          let _hashes = hash.split('#').filter(function (i) {return i;});

          if (mode === 'object')
          {
            return PROCESS.query(_hashes.length > 1 ? _hashes[1] : _hashes[0], data, 'object');
          } else

          {
            return _hashes[0] + '#' + PROCESS.query(_hashes[1], data);
          }
        }
        return {};
      };

      if (Array.isArray(target))
      {
        result = [];
        for (let i = 0; i < target.length; i++)
        {
          result[i] = function___processHash(target, data, mode);
        }
      } else
      if (typeof string == 'object')
      {
        result = {};
        for (let atarget in target)
        {
          result[atarget] = function___processHash(target[atarget], data, mode);
        }
      } else

      {
        result = function___processHash(target, data, mode);
      }
      return result;
    };

    PROCESS.format_date = function (timestamp, format = 'default', show_time = false)
    {
      var date = null;

      var return_date = '';

      const calculateTimimg = function (d) {
        let months = 0,years = 0,days = 0,weeks = 0,total = d;
        while (d) {
          if (d >= 365) {
            years++;
            d -= 365;
          } else if (d >= 30) {
            months++;
            d -= 30;
          } else if (d >= 7) {
            weeks++;
            d -= 7;
          } else {
            days++;
            d--;
          }
        }return {
          years, months, weeks, days, total };

      };

      switch (timestamp) {

        case "now":
        case "today":
          date = new Date();
          break;
        case "yesterday":
          date = new Date();
          date.setDate(date.getDate() - 1);
          break;
        case "tomorrow":
          date = new Date();
          date.setDate(date.getDate() + 1);
          break;
        default:
          if (!isNaN(timestamp))
          {
            date = new Date(timestamp * 1000);
          } else

          {
            // Assume mysql timestamp
            /**
            console.debug(timestamp);
            let t = timestamp.split(/[- :]/);
            console.debug(t);
            date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
            console.debug(date);
            */
            date = new Date(timestamp);
          }
          break;}


      switch (format) {

        case "timestamp_y-m-d":
          return_date = new Date(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2)).getTime() / 1000;
          break;
        case "Y-m-d":
          return_date = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
          break;
        case "since":
          //calculate time difference
          var time_difference = new Date().getTime() - date.getTime();

          //calculate days difference by dividing total milliseconds in a day
          let dwmy = calculateTimimg(Math.trunc(time_difference / (1000 * 60 * 60 * 24)));

          let _return_date = [];

          if ('years' in dwmy && dwmy.years > 0)
          {
            _return_date.push(dwmy.years + ' year' + (dwmy.years == 1 ? '' : 's'));
          }

          if ('months' in dwmy && dwmy.months > 0)
          {
            _return_date.push(dwmy.months + ' month' + (dwmy.months == 1 ? '' : 's'));
          }

          if ('weeks' in dwmy && dwmy.weeks > 0)
          {
            _return_date.push(dwmy.weeks + ' week' + (dwmy.weeks == 1 ? '' : 's'));
          }

          if ('days' in dwmy && dwmy.days > 0)
          {
            _return_date.push(dwmy.days + ' day' + (dwmy.days == 1 ? '' : 's'));
          }

          return_date = dwmy;

          return_date.string = _return_date.join(", ");

          break;
        default:
          const nth = function (d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
              case 1:return "st";
              case 2:return "nd";
              case 3:return "rd";
              default:return "th";}

          };

          var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          var year = date.getFullYear();
          var month = months[date.getMonth()];
          var day = date.getDate();

          // Hours part from the timestamp
          var hours = date.getHours();
          // Minutes part from the timestamp
          var minutes = "0" + date.getMinutes();

          // Will display time in YYYY/MM/DD 10:30:23 format
          if (show_time)
          {
            return_date = day + '' + nth(day) + ' ' + month + ' ' + year + ' at ' + hours + ':' + minutes.substr(-2);
          } else

          {
            return_date = day + '' + nth(day) + ' ' + month + ' ' + year;
          }}


      return return_date;
    };

    PROCESS.moustache = function (target, data = {})
    {
      let result = '';
      let function__prepData = function (data = {}) {
        let template_data = JSON.parse(JSON.stringify(data));
        if ('::timestamp_to_date' in template_data)
        {
          template_data.date = function () {
            return PROCESS.format_date(template_data['::timestamp_to_date'], 'Y-m-d');
          };
        }
        template_data.today = function () {
          return PROCESS.format_date('now', 'Y-m-d');
        };
        if (!('date' in template_data))
        {
          template_data.date = function () {
            return PROCESS.format_date('now', 'Y-m-d');
          };
        }
        template_data.yesterday = function () {
          return PROCESS.format_date('yesterday', 'Y-m-d');
        };
        template_data.yesterday_timestamp = function () {
          return PROCESS.format_date('yesterday', 'timestamp_y-m-d');
        };
        template_data.today_timestamp = function () {
          return PROCESS.format_date('now', 'timestamp_y-m-d');
        };
        template_data.tomorrow = function () {
          return PROCESS.format_date('tomorrow', 'Y-m-d');
        };

        let env_context = _HELPERS.run('env', 'getContext', [false, function () {return {};}]);
        if (typeof env_context === 'object' && env_context !== null)
        {
          template_data['env'] = {};
          template_data['env']['context'] = env_context;
        }
        if (typeof MATCH === 'object')
        {
          for (let a_match in MATCH)
          {
            if (typeof MATCH[a_match] === 'object')
            {
              if ('function' in MATCH[a_match])
              {
                template_data[a_match] = MATCH[a_match].function();
              } else
              if ('values' in MATCH[a_match])
              {
                if (Array.isArray(MATCH[a_match].values))
                {
                  template_data[a_match] = MATCH[a_match].values.join(',');
                } else

                {
                  template_data[a_match] = MATCH[a_match].values;
                }
              } else

              {
                template_data[a_match] = '';
              }
            } else

            {
              template_data[a_match] = MATCH[a_match];
            }
          }
        }
        return template_data;
      };
      let function___processMoustache = function (template, data = {})
      {
        //console.error('@@',template_data,env_context);
        if (!_HELPERS.has('moustache', 'render'))
        {
          _LOG('warning', 'moustache', 'Helper helper(moustache,render) required! Returning result unaffected.');
          return template;
        } else

        {
          return _HELPERS.run('mustache', 'render', [template, template_data]);
        }
      };

      let target_data = function__prepData(data);
      if (Array.isArray(target))
      {
        result = [];
        for (let i = 0; i < target.length; i++)
        {
          result[i] = function___processMoustache(target, target_data);
        }
      } else
      if (typeof target === 'object')
      {
        result = {};
        for (let atarget in target)
        {
          result[atarget] = function___processMoustache(target[atarget], target_data);
        }
      } else

      {
        result = function___processMoustache(target, target_data);
      }
      return result;
    };

    PROCESS.deserialize = function (string, params = {}, mode = '')
    {
      if (typeof string === 'string')
      {
        try
        {
          if (string.startsWith("{'"))
          {
            string = string.replaceAll("'", '"');
          }
          string = JSON.parse(`` + string + ``);
        }
        catch (ex)
        {
          try
          {
            string = JSON.parse(atob(`` + string + ``));
          }
          catch (ex)
          {
            // Ok
          }
        }
        return string;
      }
      throw 'Not a string';
    };

    PROCESS.comment = function (element, alias = '')
    {
      let return_content = {};
      if (element instanceof HTMLElement)
      {
        let comments = Array.from(element.childNodes).
        filter(node => node.nodeType === Node.COMMENT_NODE).
        map(comment => comment.textContent.trim());
        for (let i = 0; i < comments.length; i++)
        {
          let comment_key = '';
          let first_line_char = comments[i].indexOf("\n");
          let first_line = comments[i].slice(0, first_line_char).trim();
          let this_comment = comments[i].slice(first_line_char, comments[i].length).trim();
          if (first_line.startsWith('[') && first_line.endsWith(']'))
          {
            comment_key = first_line.replaceAll('[', '').replaceAll(']', '');
          }
          if (comment_key.length > 0)
          {
            try
            {
              this_comment = PROCESS.deserialize(this_comment);
            }
            catch (ex)
            {
              // Ok.... no then
            }
            _LOG('debug', 'comment', 'Comment [' + i + '](' + comment_key + ')', comments[i]);
            if (alias.length > 0)
            {
              if (comment_key == alias)
              {
                return this_comment;
              }
            } else

            {
              return_content[comment_key] = this_comment;
            }
          }
        }
      }
      if (alias.length > 0)
      {
        return null;
      }
      return return_content;
    };

    PROCESS.data = function (data, params = {}, mode = 'ommit')
    {
      let function___processData = function (data, params)
      {
        let _function__matchValues = function (type, field_value, data_value) {
          if (!Array.isArray(data_value))
          {
            data_value = [data_value];
          }
          for (let adata_value of data_value)
          {
            switch (type) {

              case "not":
                if (adata_value !== field_value)
                {
                  return true;
                }
                break;
              default:
                if (typeof field_value === 'object' && typeof adata_value === 'object')
                {
                  if (adata_value == field_value)
                  {
                    return true;
                  }
                } else
                if ("" + adata_value == "" + field_value)
                {
                  return true;
                }

                break;}

          }
          return false;
        };
        let _function__recursiveTest = function (data, field, field_value) {
          //console.error('#_processData._function__recursiveTest...',data,field,field_value);
          if (!Array.isArray(field))
          {
            field = field.split('.');
          }
          let thisField = field[0];
          if (thisField in data)
          {
            //console.error('#_processData@1',thisField);
            if (field.length == 1)
            {
              //console.error('#_processData@2',field);
              if (!(typeof field_value === 'object'))
              {
                let _field_value = field_value;
                field_value = {};
                field_value.eq = _field_value;
              }
              //console.error('#_processData@3',field_value);
              for (let _a_field_value_type in field_value)
              {
                let explode_values = field_value[_a_field_value_type];
                if (!Array.isArray(explode_values))
                {
                  explode_values = explode_values.split(';');
                }
                if (explode_values.length == 1)
                {
                  explode_values = explode_values[0].split(',');
                }
                //console.error('#_processData@4',explode_values);
                let success_count = 0;
                _LOG('debug', '_processData', '_function__recursiveTest', [_a_field_value_type, explode_values, data[thisField]]);
                for (let i = 0; i < explode_values.length; i++)
                {
                  if (_function__matchValues(_a_field_value_type, explode_values[i], data[thisField]))
                  {
                    _LOG('debug', '_processData', 'Success _function__matchValues', [_a_field_value_type, explode_values[i], data[thisField]]);
                    success_count++;
                  } else

                  {
                    _LOG('debug', '_processData', 'Failed _function__matchValues', [_a_field_value_type, explode_values[i], data[thisField]]);
                  }
                }
                if (success_count > 0)
                {
                  return true;
                } else

                {
                  return false;
                }
              }
            } else

            {
              field.shift();
              return _function__recursiveTest(data[thisField], field, field_value);
            }
          }
          throw 'Unknown';
        };

        let count = 0;
        let offset = '_[offset]' in params ? params['_[offset]'] : 0;
        let limit = '_[limit]' in params ? params['_[limit]'] : 0;
        let sort = '_[sort]' in params ? params['_[sort]'] : false;
        let distinct_limit = '_[distinct|limit]' in params ? params['_[distinct|limit]'] : false;


        let continue_processing = true;
        _LOG('debug', '_processData', 'Processing ' + data.length + ', items...', data);
        for (let i = 0; i < data.length; i++)
        {
          if (!continue_processing)
          {
            break;
          }
          let is_deleted = false;
          for (let a_param in params)
          {
            if (!a_param.startsWith('_') && !is_deleted)
            {
              try
              {
                _LOG('debug', '_processData', 'function___processData', { 'data[i]': data[i], 'a_param': a_param, 'params[a_param]': params[a_param] });
                if (!_function__recursiveTest(data[i], a_param, params[a_param]))
                {
                  throw 'no-match';
                }
              }
              catch (ex)
              {
                if (mode === 'ommit')
                {
                  //console.error('#function___processData::delete',JSON.stringify(data[i]),params);
                  delete data[i];
                  is_deleted = true;
                  break;
                }
              }
            }
          }
          if (!is_deleted)
          {
            count++;
            if (offset > 0 && count < offset)
            {
              delete data[i];
            }
            if (limit > 0 && count > limit)
            {
              continue_processing = false;
            }
          }
        }
        let post_process_data = false;
        if (sort)
        {
          post_process_data = true;
          if (!Array.isArray(sort))
          {
            sort = sort.split(',');
          }
        }
        if (distinct_limit)
        {
          post_process_data = true;

          let _distinct_limit = {};
          distinct_limit = distinct_limit.split('|');
          if (distinct_limit.length == 2)
          {
            _distinct_limit[distinct_limit[0]] = distinct_limit[1];
          }
          distinct_limit = _distinct_limit;
        }
        if (post_process_data)
        {
          let processed_data = [];
          let function__sort = function (fields) {
            return function (a, b) {
              return fields.
              map(function (o) {
                var dir = 1;
                if (o[0] === '-') {
                  dir = -1;
                  o = o.substring(1);
                }
                if (o[0] === '+') {
                  o = o.substring(1);
                }
                if (a[o] > b[o]) return dir;
                if (a[o] < b[o]) return -dir;
                return 0;
              }).
              reduce(function firstNonZeroValue(p, n) {
                return p ? p : n;
              }, 0);
            };
          };

          let has_sort = false;
          let has_distinct_limit = false;
          for (let i = 0; i < data.length; i++)
          {
            let aProcessableRecord = {};
            aProcessableRecord['::data_id'] = i;

            if (typeof distinct_limit === 'object')
            {
              for (let distinct_limit_key in distinct_limit)
              {
                let keys = distinct_limit_key.split(',');
                let value = [];
                for (let akey of keys)
                {
                  value.push(PROCESS.getDataValue(data[i], akey));
                }
                aProcessableRecord[distinct_limit_key] = btoa(value.join('#'));
                has_distinct_limit = true;
              }
            }

            if (sort.length > 0)
            {
              for (let a_sort_item of sort)
              {
                if (a_sort_item[0] === '-' || a_sort_item[0] === '+') {
                  a_sort_item = a_sort_item.substring(1);
                }
                aProcessableRecord[a_sort_item] = PROCESS.getDataValue(data[i], a_sort_item);
                has_sort = true;
              }
            }
            processed_data.push(aProcessableRecord);
          }
          if (has_sort)
          {
            processed_data = processed_data.sort(function__sort(sort));
          }
          if (has_distinct_limit)
          {
            let distinct_limit_count = {};
            for (let i = 0; i < processed_data.length; i++)
            {
              if (typeof processed_data[i] === 'object')
              {
                let this_processed_data = processed_data[i];
                for (let distinct_limit_key in distinct_limit)
                {
                  if ("" + distinct_limit_key in this_processed_data)
                  {
                    if ("" + this_processed_data[distinct_limit_key] in distinct_limit_count)
                    {
                      if (distinct_limit_count[this_processed_data[distinct_limit_key]] > 0)
                      {
                        --distinct_limit_count[this_processed_data[distinct_limit_key]];
                      } else

                      {
                        delete processed_data[i];
                      }
                    } else

                    {
                      distinct_limit_count[this_processed_data[distinct_limit_key]] = distinct_limit[distinct_limit_key];
                    }
                  }
                }
              }
            }
          }
          processed_data = processed_data.filter(function (i) {return i;});
          let new_data = [];
          _LOG('debug', '_processData', 'Post processing 01' + data.length + ', items...', { 'processed_data': processed_data, 'sort': sort, 'distinct_limit': distinct_limit });
          for (let i = 0; i < processed_data.length; i++)
          {
            if ('::data_id' in processed_data[i])
            {
              new_data.push(data[processed_data[i]['::data_id']]);
            }
          }
          data = new_data;
          _LOG('debug', '_processData', 'Post processing ' + data.length + ', items...', { 'processed_data': processed_data, 'sort': sort, 'distinct_limit': distinct_limit });
        }
        return data.filter(function (i) {return i;});
      };

      if (Array.isArray(data))
      {
        data = function___processData(data, params);
      } else

      {
        data = function___processData([data], params);
        if (data.length > 0)
        {
          data = data[0];
        }
      }

      return data;
    };

    PROCESS.getDataValue = function (data, key, default_value = null)
    {
      let _function__recursiveGet = function (data, field) {
        //console.error('process.getDataValue._function__recursiveGet...',data,field);
        if (!Array.isArray(field))
        {
          field = field.split('.');
        }
        let thisField = field[0];
        if (thisField in data)
        {
          if (field.length == 1)
          {
            //console.error('process.getDataValue._function__recursiveGet... Found '+thisField,data[thisField]);
            return data[thisField];
          } else

          {
            field.shift();
            //console.error('process.getDataValue._function__recursiveGet... Found '+thisField+' recursing',field,data[thisField]);
            return _function__recursiveGet(data[thisField], field);
          }
        }
        throw 'Unknown';
      };
      try
      {
        return _function__recursiveGet(data, key);
      }
      catch (e)
      {
        return default_value;
      }
    };

    PROCESS.async_hashString = async function (inputString)
    {
      //#TODO test for support
      const encoder = new TextEncoder();
      const data = encoder.encode(inputString);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);

      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

      return hashHex;
    };

    _HELPERS.add('process', 'query', PROCESS.query);
    _HELPERS.add('process', 'hash', PROCESS.hash);
    _HELPERS.add('process', 'moustache', PROCESS.moustache);
    _HELPERS.add('process', 'comment', PROCESS.comment);
    _HELPERS.add('process', 'data', PROCESS.data);
    _HELPERS.add('process', 'async_hashString', PROCESS.async_hashString);
    _HELPERS.add('process', 'deserialize', PROCESS.deserialize);
  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

function formatHelper(_HELPERS, _FILTERS) {

  let _LOG = function (type, source, message, data = '')
  {
    source = 'helper-format.' + source;
    if ('has' in _HELPERS && _HELPERS.has('tools', 'logging'))
    {
      _HELPERS.run('tools', 'logging', [type, source, message, data]);
    } else

    {
      let _message = source + '- ' + message;
      switch (type) {

        case "debug":
          console.debug(_message, data);
          break;
        case "warning":
          console.warn(_message, data);
        case "info":
          console.info(_message, data);
          break;
        case "error":
          console.error(_message, data);
          break;
        default:
          console.log(_message, data);}

    }
  };
  if ('add' in _HELPERS && 'has' in _HELPERS)
  {
    let FORMAT = {};

    FORMAT.date = function (timestamp, format = 'default', show_time = false)
    {
      let date = null;

      let return_date = '';

      const calculateTimimg = function (d) {
        let months = 0,years = 0,days = 0,weeks = 0,total = d;
        while (d) {
          if (d >= 365) {
            years++;
            d -= 365;
          } else if (d >= 30) {
            months++;
            d -= 30;
          } else if (d >= 7) {
            weeks++;
            d -= 7;
          } else {
            days++;
            d--;
          }
        }return {
          years, months, weeks, days, total };

      };

      switch (timestamp) {

        case "now":
        case "today":
          date = new Date();
          break;
        case "yesterday":
          date = new Date();
          date.setDate(date.getDate() - 1);
          break;
        case "tomorrow":
          date = new Date();
          date.setDate(date.getDate() + 1);
          break;
        default:
          if (!isNaN(timestamp))
          {
            //date = new Date(timestamp * 1000);
            date = new Date(parseInt(timestamp, 10) * 1000);
          } else

          {
            // Assume mysql timestamp
            /**
            console.debug(timestamp);
            let t = timestamp.split(/[- :]/);
            console.debug(t);
            date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
            console.debug(date);
            */
            date = new Date(timestamp);
          }
          break;}


      if (date.toString() !== `Invalid Date` && !isNaN(date.getTime()))
      {
        switch (format) {

          case "DateObject":
            return_date = date;
            break;
          case "timestamp_y-m-d":
            return_date = new Date(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2)).getTime() / 1000;
            break;
          case "Y-m-d":
            return_date = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
            break;
          case "since":
            //calculate time difference
            var time_difference = new Date().getTime() - date.getTime();

            //calculate days difference by dividing total milliseconds in a day
            let dwmy = calculateTimimg(Math.trunc(time_difference / (1000 * 60 * 60 * 24)));

            let _return_date = [];

            if ('years' in dwmy && dwmy.years > 0)
            {
              _return_date.push(dwmy.years + ' year' + (dwmy.years == 1 ? '' : 's'));
            }

            if ('months' in dwmy && dwmy.months > 0)
            {
              _return_date.push(dwmy.months + ' month' + (dwmy.months == 1 ? '' : 's'));
            }

            if ('weeks' in dwmy && dwmy.weeks > 0)
            {
              _return_date.push(dwmy.weeks + ' week' + (dwmy.weeks == 1 ? '' : 's'));
            }

            if ('days' in dwmy && dwmy.days > 0)
            {
              _return_date.push(dwmy.days + ' day' + (dwmy.days == 1 ? '' : 's'));
            }

            return_date = dwmy;

            return_date.string = _return_date.join(", ");

            break;
          default:
            const nth = function (d) {
              if (d > 3 && d < 21) return 'th';
              switch (d % 10) {
                case 1:return "st";
                case 2:return "nd";
                case 3:return "rd";
                default:return "th";}

            };

            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var year = date.getFullYear();
            var month = months[date.getMonth()];
            var day = date.getDate();

            // Hours part from the timestamp
            var hours = date.getHours();
            // Minutes part from the timestamp
            var minutes = "0" + date.getMinutes();

            // Will display time in YYYY/MM/DD 10:30:23 format
            if (show_time)
            {
              return_date = day + '' + nth(day) + ' ' + month + ' ' + year + ' at ' + hours + ':' + minutes.substr(-2);
            } else

            {
              return_date = day + '' + nth(day) + ' ' + month + ' ' + year;
            }}

      }
      return return_date;
    };

    FORMAT.structure = function (data = [], dataFormat = {})
    {
      try
      {

        // Util helper to find key value within specified data
        const function__keyValue = (keys, data) => keys.reduce((val, key) => val[key], data);

        // Util: return if var !== undefined;
        const function__isDefined = v => v !== undefined;

        // Util: return concatenated key values from specified data
        const function__fieldKeyValue = (key, data) => {
          let regExp = /{(.*?)}/g;
          let splitArr = function__isDefined(key) ? key.split(`|`) : null;
          if (splitArr !== null && splitArr.length > 1) {
            // Check if at least one key in splitArr is valid
            let validKeys = splitArr.some(key => {
              let keyValue = function__keyValue(key.split(`.`), data);
              return function__isDefined(keyValue) && keyValue.length;
            });
            if (!validKeys) {return ``;}

            let replaceArr = splitArr.reduce((arr, key) => {
              let replaceKeyValue = key.match(regExp) ? key.replace(/{|}/g, ``) : function__keyValue(key.split(`.`), data);
              return function__isDefined(replaceKeyValue) && replaceKeyValue.length ? arr.concat(replaceKeyValue) : arr;
            }, []);
            return replaceArr.length ? replaceArr.join(``) : ``;
          }

          // Check if there is an alias OR a valid key
          return function__isDefined(key) ? /#[a-z0-9_]+/i.test(key) ? key.replace(/{|}/g, ``) : function__keyValue(key.split(`.`), data) : ``;
        };

        // Util: return dynamic fields
        const function__createDynamicFields = (data, dataField) => {
          let fieldValues = {};
          return data.reduce((fields, instrument) => {
            let value = function__isDefined(dataField.key) ? function__fieldKeyValue(dataField.key, instrument) : undefined;
            let label = function__isDefined(dataField.label) && dataField.label.length ? `${dataField.label}: ${value}` : value;

            if (function__isDefined(value) && !(label in fieldValues)) {
              let field = Object.assign({}, dataField);
              field.value = value;
              field.label = label;
              fieldValues[label] = value;

              return fields.concat(field);
            }
            return fields;
          }, []);
        };

        let xFields = dataFormat.x.fields;
        // This is so yFields isn't completely empty (for looping over), however the item {key: xFields[0].key} will not be used in this case
        let yFields = function__isDefined(dataFormat.y) && function__isDefined(dataFormat.y.fields) ? dataFormat.y.fields : [{ key: xFields[0].key }];
        let xDefaults = xFields[0].default ? xFields[0] : {};
        let yDefaults = yFields[0].default ? yFields[0] : {};
        let xLabel = function__isDefined(xDefaults.label) ? xDefaults.label : ``;
        let yLabel = function__isDefined(dataFormat.y) && dataFormat.y.show === false ? `_` : ``;
        let aliases = function__isDefined(dataFormat.aliases) ? dataFormat.aliases : [];

        if (function__isDefined(yDefaults.label)) {
          yLabel = yDefaults.label;
        } else if (function__isDefined(dataFormat.y) && function__isDefined(dataFormat.y.datapoint) && function__isDefined(dataFormat.y.datapoint[0].label)) {
          yLabel = dataFormat.y.datapoint[0].label;
        }

        if (xFields.length === 1 && yFields[0].key !== xFields[0].key && !function__isDefined(xFields[0].value)) {
          xFields = function__createDynamicFields(data, xFields[0]);
        }
        if (yFields.length === 1 && yFields[0].key !== xFields[0].key && !function__isDefined(yFields[0].value)) {
          yFields = function__createDynamicFields(data, yFields[0]);
        }

        let xHeaders = data.reduce((headers, table) => {
          for (let i = 0; i < xFields.length; i++) {
            const xField = xFields[i];
            let xKeyVal = function__isDefined(xField.key) ? function__fieldKeyValue(xField.key, table) : undefined;
            let xHeader = function__isDefined(xField.label) ? xField.label : xField.key;

            if (function__isDefined(dataFormat.y) && function__isDefined(dataFormat.y.datapoint)) {
              xHeader = function__isDefined(xField.label) && function__isDefined(dataFormat.y.fields) ? xField.label : function__isDefined(xKeyVal) ? xKeyVal : undefined;
            }

            if (function__isDefined(xHeader) && headers.indexOf(xHeader) === -1 && !/#[a-z0-9_]+/i.test(xHeader)) {headers.push(`${xHeader}`);}
          }
          return headers;
        }, []);

        // Fill in dataTable table with y, x, and cell values
        let dataObj = data.reduce((tables, table, index) => {

          let aliasValues = aliases.reduce((vals, alias) => {
            let aliasValue = function__isDefined(alias.key) ? function__fieldKeyValue(alias.key, table) : undefined;

            // Note: function__fieldKeyValue will return undefined
            if (!function__isDefined(aliasValue))
            {
              if (function__isDefined(alias.value))
              {
                aliasValue = alias.value;
              } else
              {
                aliasValue = ``;
              }
            }


            let aliasFormat = alias.format;
            if (typeof aliasFormat === `string`) {
              aliasFormat = aliasFormat.replace(/\{(.+?)\}/gi, (match, p1) => {
                return function__keyValue(p1.split(`.`), table) || p1;
              });
            }
            aliasValue = function__isDefined(aliasFormat) ? FORMAT.value(aliasValue, aliasFormat) : aliasValue;
            if (function__isDefined(alias.label) && function__isDefined(aliasValue)) {vals[`#${alias.label}`] = aliasValue;}

            return vals;
          }, {});
          let datasplit = function__isDefined(dataFormat.datasplit) ? function__fieldKeyValue(dataFormat.datasplit, table) : ``;
          let splitKey = function__isDefined(dataFormat.caption) ? dataFormat.caption : ``;

          if (function__isDefined(datasplit) && datasplit.length) {
            splitKey += splitKey.length ? ` - ${datasplit}` : datasplit;
          }

          for (let label in aliasValues) {
            splitKey = splitKey.replace(label, aliasValues[label]);
          }

          if (!tables.has(splitKey)) {tables.set(splitKey, new Map());}

          // for (let yField of yFields) {
          // Using regular for-loop because of IE11
          // .. and https://daverupert.com/2017/10/for-of-loops-are-bad/
          for (let yfI = 0, yfL = yFields.length; yfI < yfL; yfI++) {
            const yField = yFields[yfI];

            if (yField.default && yFields.length > 1) continue;

            let yDef = function__isDefined(dataFormat.y) && function__isDefined(dataFormat.y.fields);
            let yKey = function__isDefined(yField.key) ? yField.key : yDefaults.key;
            let yKeyVal = function__isDefined(yKey) ? function__fieldKeyValue(yKey, table) : undefined;

            if (function__isDefined(yKeyVal) && (yKeyVal === yField.value || yField.default || !yDef)) {
              // for (let xField of xFields) {
              for (let xfI = 0, xfL = xFields.length; xfI < xfL; xfI++) {
                const xField = xFields[xfI];

                if (xField.default && xFields.length > 1) continue;

                let xKey = function__isDefined(xField.key) ? xField.key : xDefaults.key;
                let xKeyVal = function__isDefined(xKey) ? function__fieldKeyValue(xKey, table) : undefined;

                if (function__isDefined(xKeyVal) && (xKeyVal === xField.value || xField.default || !yDef)) {
                  let yHeader = index;
                  let xHeader = function__isDefined(xField.label) ? xField.label : xField.key;
                  let cellValue = xKeyVal;

                  // TODO: refactor this if-else block?
                  if (function__isDefined(dataFormat.y)) {
                    if (function__isDefined(dataFormat.y.datapoint)) {
                      if (function__isDefined(dataFormat.y.fields)) {
                        yHeader = function__isDefined(yField.label) && !yField.default ? yField.label : yKeyVal;
                        xHeader = function__isDefined(xField.label) && !xField.default ? xField.label : xKeyVal;
                        cellValue = function__isDefined(dataFormat.y.datapoint[0].key) ? function__fieldKeyValue(dataFormat.y.datapoint[0].key, table) : undefined; // For now just using datapoint[0]
                      } else {
                        yHeader = 0;
                        xHeader = xKeyVal;
                        cellValue = function__isDefined(dataFormat.y.datapoint[0].key) ? function__fieldKeyValue(dataFormat.y.datapoint[0].key, table) : undefined;
                      }
                    }
                    yHeader = dataFormat.y.show === false ? `_${yHeader}` : yHeader;
                  }


                  /* -------------------------------------------------------------
                    * UPDATE cell formatter (in some cases) with
                    * data from _other_ fields.
                    *
                    * @TODO @FIXME
                    *
                    * hardcoded for specific cases at this time
                    *
                    * - {fields.xyz} gets replaced with proper fields.xyz
                    *   value, if available
                    * ------------------------------------------------------------- */
                  let cellFormat = xField.format;
                  if (typeof cellFormat === `string`) {
                    cellFormat = cellFormat.replace(/\{(.+?)\}/gi, (match, p1) => {// eslint-disable-line no-unused-vars
                      // Check if matched replacement
                      // *does exist* for current Instrument
                      //
                      // e.g. {fields.date}
                      // - exists as key?  => replace!
                      // - Does not exist? => return original
                      return function__keyValue(p1.split(`.`), table) || p1;
                    });
                  }
                  /* ------------------------------------------------------------- */

                  cellValue = function__isDefined(cellValue) && `${cellValue}`.length ? function__isDefined(cellFormat) ? FORMAT.value(cellValue, cellFormat) : cellValue : `-`;

                  for (let label in aliasValues) {
                    cellValue = `${cellValue}`.replace(label, aliasValues[label]);
                    yHeader = `${yHeader}`.replace(label, aliasValues[label]);
                    xHeader = `${xHeader}`.replace(label, aliasValues[label]);
                  }

                  if (!tables.get(splitKey).has(yHeader)) {
                    let xCells = xHeaders.reduce((headers, header) => {headers.set(header, `-`);return headers;}, new Map());
                    tables.get(splitKey).set(yHeader, xCells);
                  }

                  tables.get(splitKey).get(yHeader).set(xHeader, cellValue);
                }
              }
            }
          }
          return tables;
        }, new Map());

        // Run any format.data filters

        if (_FILTERS.has('format.data'))
        {
          [dataFormat, dataObj, xLabel, yLabel] = _FILTERS.apply('format.data', [dataFormat, dataObj, xLabel, yLabel]);
        }

        return [dataObj, xLabel, yLabel];
      }
      catch (ex)
      {
        _LOG('error', 'structure', 'Error formatting structure...', { 'data': data, 'dataFormat': dataFormat, 'ex': ex });
        throw { 'ex': ex, 'data': data, 'dataFormat': dataFormat };
      }
    };

    FORMAT.value = function (value = '', format = '', ...params)
    {
      _LOG('debug', 'value', 'Formatting ' + value + ' with ' + format + '...', params);
      try
      {
        let function___getParam = function (param, fallback) {

          if (!params) return fallback;

          let _return = fallback;

          // Using for-loops instead of Array.forEach()
          // because for-loops can be short-circuited with `break`
          for (let i = 0, l = params.length; i < l; i++) {

            if (typeof params[i] === `string`) {

              // Try and fetch param value from String: 'paramKey:paramValue, foo:bar'
              const _params = params[i].trim().split(PARAMS_SEPARATOR);
              for (let _i = 0, _l = _params.length; _i < _l; _i++) {

                let _pair = _params[_i].split(PARAM_SEPARATOR);

                // Handle string values with `:`
                // (in this case: `http:`)
                // - here we cannot split on :
                //   so we need to re-attach _pair[1] ("http") with _pair[2] (url)

                // .split(':') returned MORE than 2 parts
                // Bail and Return fallback
                if (_pair.length > 3) break;

                if (_pair.length === 3) {
                  // .split(':') returned 3 parts
                  // We have 1 split too much. (Probably "http:")
                  // re-attach last 2 splits as one...
                  // e.g: ["href", "http", "//nu.nl/"] => ["href", "http://nu.nl/"]
                  const rePaired = `${_pair[1]}:${_pair[2]}`; // Re-Joined [1]:[2] parts
                  _pair[1] = rePaired; // re-add re-attached pair "http://nu.nl/"
                  _pair = _pair.splice(0, 2); // Keep only [0] and [1]
                }

                if (_pair[0].trim() === param) {
                  _return = _pair[1].trim();
                  break;
                }
              }

            } else if (typeof params[i] === `object`) {

              // Try and fetch { paramKey: "paramValue" }
              if (params[i][param]) {
                _return = params[i][param];
                break;
              }

            }

          }

          return _return;
        };

        /* SETUP CONSTANTS ======================================================= */
        const OPTIONS_SEPARATOR = `|`; // "<format>[|]<optKey:optVal>"                     => "currency|currency:EUR"
        const PARAM_SEPARATOR = `:`; // "<paramKey>[:]<paramVal>"                        => "lang:nl-NL"
        const PARAMS_SEPARATOR = `,`; // "<paramKey>:<paramVal>[,] <paramKey>:<paramVal>" => "lang:nl-NL, currency:EUR"

        const SYMBOL_EMPTY_VALUE = `—`; // Empty Cell Value symbol

        // https://stackoverflow.com/a/25603630
        // const FALLBACK_LOCALE   = (navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage)) || `en-EN`;
        const FALLBACK_LOCALE = `en-EN`;
        const FALLBACK_CURRENCY = `EUR`;

        /**
                                         * Normalize Zero display
                                         * "0,0"  => "0"
                                         * "0.0"  => "0"
                                         * "0,00" => "0"
                                         * "0.00" => "0"
                                         * .. etc
                                         */
        const normalizeZero = z => /^[-+]?0{1,}[,.]0{1,}$/.test(z) ? `0` : z;

        /**
                                                                              * Is window.Intl supported?
                                                                              */
        const SUPPORTS_INTL = !!(`Intl` in window);


        // https://mzl.la/2Ejpchr
        const DATE_OPTIONS = {
          // timeZone: `Europe/London`,
          // weekday: `long`,
          year: `numeric`, // or '2-digit'
          month: `2-digit`,
          day: `2-digit` };


        // Fallback
        const _ORIGINAL_VALUE = value;

        // BAIL if no proper input (null, undefined, ``): return ``
        if (!_ORIGINAL_VALUE) return ``;

        // Cast to String and Trim spaces
        let _VALUE = _ORIGINAL_VALUE.toString().trim();

        // Remove empty params[]
        params = params.length ? params : undefined;
        // .. but re-add if they're given _as part_ of format: `format|opts`
        if (!params && typeof format === `string`) {
          const formatPair = format.split(OPTIONS_SEPARATOR);
          format = formatPair[0];
          params = formatPair[1] && new Array(formatPair[1]);
        }


        /**
          * FRACTION DECIMALS
          * In the MarketPrices API all(!?) prices and changes are stored
          * with 3 decimal fractions and a point "." as separator (1.000)
          *
          * BUT, we show max 2 fractions IF our last (3d) fraction is zero:
          * (with a localised fraction separator: "," in NL, "." in US EN)
          *
          * So:
          *     "100"     => "100,00"
          *     "100.1"   => "100,10"
          *     "100.10"  => "100,10"
          *     "100.100" => "100,10"
          *
          * BUT (3d fraction is meaningfull here):
          *     "100.001" => "100,001"
          *     "100.101" => "100,101"
          *
          * = We do not round ourself!
          * = We always <display> 2 decimal fractions
          * = .. UNLESS there's a significant third..
          */
        const DB_FRACTION_SEPARATOR = `.`;
        const DB_FRACTION_DIGITS = function___getParam(`digits`, 3);
        const RE_FRACTION_DIGITS = new RegExp(`\\${DB_FRACTION_SEPARATOR}\\d{${DB_FRACTION_DIGITS}}$`, `g`);
        let FRACTION_DIGITS = 2; // `let` because we can override to 3 when input has 3d fraction

        /**
        * Reurn necessary meaninful fraction decimals
        * -> Only 2 (FRACTION_DIGITS) by default
        * -> But 3 (DB_FRACTION_DIGITS) when 3d digit is not "0"
        *
        * @param nr input (String) of number to check fraction decimals of
        * @returns FRACTION_DIGITS 2 or 3 digits to use.
        */
        const function__getMinimumFractionDigits = nr => RE_FRACTION_DIGITS.test(nr) && nr.substr(-1) !== `0` ? DB_FRACTION_DIGITS : FRACTION_DIGITS;

        // Params SHARED between formats
        // Get it once for all formats needed
        // @TODO Take locale from App setting `lang`?
        const _LOCALE = function___getParam(`lang`, FALLBACK_LOCALE);




        /* FORMATTERS ============================================================ */


        /**
                                                                                      * Format as FUNCTION
                                                                                      * ----------------------------------------------------------------------- */
        if (typeof format === `function`) {return format(_ORIGINAL_VALUE);}

        /**
                                                                            * Format as STRING
                                                                            * ----------------------------------------------------------------------- */
        if (typeof format === `string`) format = format.trim().toLowerCase();

        /**
                                                                              * ALIAS some Formats
                                                                              * ----------------------------------------------------------------------- */
        // "percents"|"percentage"|"percentages" => "percent"
        if (format.substr(0, 7) === `percent`) format = `percent`;
        if (format.substr(0, 4) === `slug`) format = `slugify`;
        if (format.substr(0, 5) === `class`) format = `classname`;
        if (format === `upper` || format === `lower` || format === `title` || format === `camel`) format += `case`;


        // Run any formatValue filter
        if (this && typeof _FILTERS.has === `function`)
        {
          // Check for specific override
          if (_FILTERS.has(`formatValue_override__${format}`))
          {
            [_VALUE, format, params] = _FILTERS.apply(`formatValue_override__${format}`, [_VALUE, format, params]);
            format = ``;
          }

          if (_FILTERS.has(`formatValue_pre`))
          {
            [_VALUE, format, params] = _FILTERS.apply(`formatValue_pre`, [_VALUE, format, params]);
          }
        }

        /* eslint-disable indent */
        switch (format) {
          case `slugify`:{
              _VALUE = _VALUE.toString().toLowerCase().trim();
              const sets = [
              { to: `a`, from: `[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]` },
              { to: `c`, from: `[ÇĆĈČ]` },
              { to: `d`, from: `[ÐĎĐÞ]` },
              { to: `e`, from: `[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]` },
              { to: `g`, from: `[ĜĞĢǴ]` },
              { to: `h`, from: `[ĤḦ]` },
              { to: `i`, from: `[ÌÍÎÏĨĪĮİỈỊ]` },
              { to: `j`, from: `[Ĵ]` },
              { to: `ij`, from: `[Ĳ]` },
              { to: `k`, from: `[Ķ]` },
              { to: `l`, from: `[ĹĻĽŁ]` },
              { to: `m`, from: `[Ḿ]` },
              { to: `n`, from: `[ÑŃŅŇ]` },
              { to: `o`, from: `[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]` },
              { to: `oe`, from: `[Œ]` },
              { to: `p`, from: `[ṕ]` },
              { to: `r`, from: `[ŔŖŘ]` },
              { to: `s`, from: `[ßŚŜŞŠ]` },
              { to: `t`, from: `[ŢŤ]` },
              { to: `u`, from: `[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]` },
              { to: `w`, from: `[ẂŴẀẄ]` },
              { to: `x`, from: `[ẍ]` },
              { to: `y`, from: `[ÝŶŸỲỴỶỸ]` },
              { to: `z`, from: `[ŹŻŽ]` },
              { to: `-`, from: `[·/_,:;']` }];


              sets.forEach(set => {_VALUE = _VALUE.replace(new RegExp(set.from, `gi`), set.to);});

              _VALUE = _VALUE.toString().toLowerCase().
              replace(/\s+/g, `-`) // Replace spaces with -
              .replace(/&/g, `-`) // Replace & with 'and' (NOTE: no longer. Simply use '-')
              .replace(/[^\w-]+/g, ``) // Remove all non-word chars
              .replace(/--+/g, `-`) // Replace multiple - with single -
              .replace(/^-+/, ``) // Trim - from start of text
              .replace(/-+$/, ``); // Trim - from end of text

              if (typeof params !== `undefined` && params !== `-`) {
                _VALUE = _VALUE.replace(/-/g, params);
              }
              break;
            }
          case `uppercase`:{
              _VALUE = _VALUE.toUpperCase();
              break;
            }
          case `lowercase`:{
              _VALUE = _VALUE.toLowerCase();
              break;
            }
          case `titlecase`:{
              // Quite Naive, but functional
              // https://stackoverflow.com/a/38530325
              _VALUE = `${_VALUE.replace(/(^|\s)\S/g, l => l.toUpperCase())}`;
              break;
            }
          case `camelcase`:{
              _VALUE = _VALUE.replace(/\W+(.)/g, (match, chr) => chr.toUpperCase());
              break;
            }
          case `ucfirst`:{
              _VALUE = _VALUE.charAt(0).toUpperCase() + _VALUE.slice(1).toLowerCase();
              break;
            }
          case `currency`:{
              // Simplest Currency formatting
              // Based on current Locale (_LOCALE)
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat

              // Only continue if Intl. is supported
              if (!SUPPORTS_INTL) break;

              try
              {
                const valueCurrency = function___getParam(`currency`, FALLBACK_CURRENCY);

                // https://gitlab.aga.rbxd.ds/proagrica-media/marketprices-app/issues/1
                // Return `-` when `currency` == 'n/a'
                if (valueCurrency === `n/a`) {
                  _VALUE = SYMBOL_EMPTY_VALUE;
                  break;
                }

                /**
                  * @NOTE
                  * Check for meaningful(!) third fractions
                  * => if found, update FRACTION_DIGITS to 3, else remain 2
                  */

                let param_digits = function___getParam(`digits`, ``).trim().split(`-`);
                let format_options = { style: `currency`, currency: valueCurrency };

                if (param_digits[0] !== undefined && param_digits[0] !== ``)
                {
                  format_options.maximumFractionDigits = param_digits[0];
                }

                if (param_digits[1] !== undefined && param_digits[1] !== ``)
                {
                  format_options.minimumFractionDigits = param_digits[1];
                } else

                {
                  format_options.minimumFractionDigits = function__getMinimumFractionDigits(_VALUE);
                }

                const formatted = new Intl.NumberFormat(_LOCALE, format_options).format(_VALUE);

                if (formatted.indexOf(`NaN`) === -1) {
                  _VALUE = `${formatted}`;
                } else {
                  _VALUE = _ORIGINAL_VALUE;
                }
              }
              catch (err)
              {
                break;
              }

              break;
            }
          case `decimal`:{
              // Simplest Decimal formatting

              // Only continue if Intl. is supported in
              if (!SUPPORTS_INTL) break;

              try {
                let param_digits = function___getParam(`digits`, ``).trim().split(`-`);
                let format_options = { style: `decimal` };

                if (param_digits[0] !== undefined && param_digits[0] !== ``)
                {
                  format_options.maximumFractionDigits = param_digits[0];
                }

                if (param_digits[1] !== undefined && param_digits[1] !== ``)
                {
                  format_options.minimumFractionDigits = param_digits[1];
                } else

                {
                  format_options.minimumFractionDigits = function__getMinimumFractionDigits(_VALUE);
                }

                const formatted = new Intl.NumberFormat(_LOCALE, format_options).format(_VALUE);
                _VALUE = `${formatted}`;

              } catch (err) {break;}

              break;
            }
          case `percent`:{
              // Simplest Percent formatting

              // Only continue if Intl. is supported in
              if (!SUPPORTS_INTL) break;

              try {
                // @NOTE
                // Percentages are fractions of 100 => (n / 100)
                // https://stackoverflow.com/a/44978655
                _VALUE = _VALUE / 100;

                var param_digits = function___getParam(`digits`, ``).trim().split(`-`);
                var format_options = { style: `percent` };

                if (param_digits[0] !== undefined && param_digits[0] !== ``)
                {
                  format_options.maximumFractionDigits = param_digits[0];
                } else

                {
                  format_options.maximumFractionDigits = DB_FRACTION_DIGITS;
                }

                if (param_digits[1] !== undefined && param_digits[1] !== ``)
                {
                  format_options.minimumFractionDigits = param_digits[1];
                }

                const formatted = new Intl.NumberFormat(_LOCALE, format_options).format(_VALUE);
                _VALUE = `${formatted}`;

              } catch (err) {
                if (this && typeof this.emit === `function`)
                {
                  this.emit(`error`, { message: `Error in formatValue(percent):: ` + err.toString() });
                }
                break;
              }

              break;
            }
          case `date`:{
              // Simplest Date formatting from UNIX timestamp
              // Based on current Locale
              // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat

              // Pass as:
              // - formatValue(`1544095193`, `date`)
              // - formatValue(`1544095193`, `date`, { lang: `nl-NL` })
              // - formatValue(`1544095193`, `date`, `lang: nl-NL`)

              // @TODO add timeZone support
              // NL: 'Europe/Amsterdam' (UTC+1)
              // UK: 'Europe/London'    (BST / UTC)

              // If this is getting too complicated, or we need more date/time fns
              // .. we should start looking at libraries, e.g.:
              // - https://date-fns.org/ - like lodash for dates
              // - https://moment.github.io/luxon/ - Moment.js's successor
              // - https://github.com/iamkun/dayjs - Fast 2kB alternative to Moment.js with the same modern API

              // Only continue if Intl. is supported
              if (!SUPPORTS_INTL) break;

              // get JS UTC Date from UNIX Timestamp
              const UTCDateObject = FORMAT.date(_VALUE, 'DateObject');

              // Bail if we could not convert to Date
              if (!UTCDateObject) break;

              // Try to convert to LOCALIZED DateTimeFormat
              // @TODO check out timeZone support in DATE_OPTIONS
              try {

                const date_format = function___getParam(`format`, ``);
                let formatted = `unknown`;
                if (date_format && typeof date_format === `string`)
                {
                  formatted = dayjs(UTCDateObject).format(date_format);
                } else

                {
                  formatted = new Intl.DateTimeFormat(_LOCALE, DATE_OPTIONS).format(UTCDateObject);
                }

                // @TODO
                // Allow for passing strftime-like formatters?
                _VALUE = `${formatted}`;
              } catch (err) {break;}

              break;
            }
          case `change`:{

              let changeNr = _VALUE;

              // - Only continue if Intl. is supported
              if (SUPPORTS_INTL) {
                try {

                  let param_digits = function___getParam(`digits`, ``).trim().split(`-`);
                  let format_options = { style: `decimal` };

                  if (param_digits[0] !== undefined && param_digits[0] !== ``)
                  {
                    format_options.maximumFractionDigits = param_digits[0];
                  }

                  if (param_digits[1] !== undefined && param_digits[1] !== ``)
                  {
                    format_options.minimumFractionDigits = param_digits[1];
                  } else

                  {
                    format_options.minimumFractionDigits = function__getMinimumFractionDigits(_VALUE);
                  }

                  const formatted = new Intl.NumberFormat(_LOCALE, format_options).format(_VALUE);
                  changeNr = `${formatted}`;

                } catch (err) {
                  changeNr = _VALUE;
                }
              }

              changeNr = normalizeZero(changeNr);
              if (!isNaN(changeNr))
              {
                let wrapper = function___getParam(`wrapper`, '#');
                _VALUE = `<span class="change change--${parseFloat(_VALUE) > 0 ? `up` : parseFloat(_VALUE) < 0 ? `down` : `equal`}">${parseFloat(_VALUE) > 0 ? `+` : ``}${changeNr}</span>`;
                _VALUE = wrapper.replace('#', _VALUE);
              } else

              {
                _VALUE = '';
              }

              break;
            }
          case `link`:{
              const _h = function___getParam(`href`, `#`);
              const _t = function___getParam(`title`, ``);
              const _x = function___getParam(`target`, ``);
              const _c = function___getParam(`classname`, ``);

              _VALUE = `<a href="${_h}"${_t ? ` title="${_t}"` : ``} class="pm-datastorebuilder-link${_c ? ` ${_c}` : ``}"${_x ? ` target="${_x}" rel="noopener"` : ``}>${_VALUE}</a>`;

              break;
            }
          case `classname`:{
              const _f = `pm-datastorebuilder-formatted`; // Fallback
              const _t = function___getParam(`tag`, `span`);
              const _c = function___getParam(`classname`, _f);

              // [1] If multiple (space separated) classnames are given
              // [2] filter out invalid classes
              // [3] if some classnames were invalid, add extra '--invalid' classname
              let _split = _c.split(` `); // [1]
              let _valid = _split.filter(c => /^[a-z_-][a-z\d_-]*$/i.test(c)); // [2]

              if (_valid.length !== _split.length) {
                // invalid classname found, add 'extra --invalid' class
                _valid.push(`${_f}--invalid`); // [3]
              }

              _VALUE = `<${_t} class="${_valid.join(` `)}">${_VALUE}</${_t}>`;

              break;
            }}



        // Run any formatValue filter
        if (_FILTERS.has('formatValue_post'))
        {
          [_VALUE, format, params] = _FILTERS.apply('formatValue_post', [_VALUE, format, params]);
        }


        return _VALUE;
      }
      catch (ex)
      {
        _LOG('error', 'value', 'Error formatting ' + value + ' with ' + format + '...', { 'params': params, 'ex': ex });
        throw { 'value': value, 'format': format, 'params': params, 'ex': ex };
      }
    };

    _HELPERS.add('format', 'date', FORMAT.date);
    _HELPERS.add('format', 'structure', FORMAT.structure);
    _HELPERS.add('format', 'value', FORMAT.value);
    _HELPERS.add('format', 'data', FORMAT.data);
  } else

  {
    _LOG('error', 'init', 'No _HELPERS.add or _HELPERS.has found!', _HELPERS);
  }

}

class HTMLDsbElement extends HTMLElement {


  constructor(_settings = {})
  {
    super();
    if (!(typeof _settings === 'object'))
    {
      _settings = {};
    }

    let _this = this;
    this._settings = false;
    this.context_name = 'HTMLDsbElement';
    if ('component_name' in _settings)
    {
      console.log('HTMLDsbElement Init ' + _settings.component_name + '...');
      this.context_name = this.context_name + '/' + _settings.component_name;
    }


    this._context_name = this.context_name;

    this._refreshContext();

    this.dsb = {};
    this.dsb.helpers = {};
    this.dsb.helpers.has = function (params)
    {
      return false;
    };
    this.dsb.filters = {};
    this.dsb.hooks = {};
    this.dsb.log = function (type, source, message, data = '')
    {
      if (_this.dsb.helpers.has('tools', 'logging'))
      {
        _this.dsb.helpers.run('tools', 'logging', [type, source, message, data]);
      } else

      {
        let _message = _this.context_name + '::' + source + '- ' + message;
        switch (type) {

          case "debug":
            console.debug(_message, data);
            break;
          case "warning":
            console.warn(_message, data);
            break;
          case "error":
            console.error(_message, data);
            break;
          default:
            console.log(_message, data);}

      }
    };

    this.dsb.element = this;
    this.dsb.original_element = null;

    if ('css' in _settings)
    {
      // Setup styling
      this.attachShadow({ mode: "open" });
      let style = document.createElement("style");
      style.textContent = _settings.css;
      let _innerHTMLCopy = this.innerHTML;
      this.innerHTML = '';
      let _innerDIV = document.createElement('div');
      if (this.hasAttribute('class'))
      {
        _innerDIV.setAttribute('class', this.getAttribute('class'));
      }

      this.shadowRoot.append(_innerDIV);
      _innerDIV.innerHTML = _innerHTMLCopy;this.shadowRoot.appendChild(style);
      this.dsb.element = _innerDIV;
      this.dsb.original_element = _innerHTMLCopy;
      this.dsb.log('debug', 'constructor', 'Setup shadowDOM. To access innerHTML use dsb.getInnerHTML');
    }

    try
    {
      filtersPart(this.dsb.filters);
      hooksPart(this.dsb.hooks);
      helpersPart(this.dsb.helpers, this);
      fetchHelper(this.dsb.helpers);
      formatHelper(this.dsb.helpers, this.dsb.filters);
      processHelper(this.dsb.helpers, this.dsb.filters);

      this.dsb.hooks.add('onFatalError', function (type, component, ex) {
        if (component instanceof HTMLElement)
        {
          _this.dsb.log('error', 'onFatalError', ex);
          component.innerHTML = '<div class-"error"><h1>A problem seems to have occured...</h1><p>' + ex + '</p>.</div>';
        }
      });
      toolsPart(this, _settings);
      this.dsb.log('debug', 'constructor', 'Finished init of HTMLDsbElement');
    }
    catch (ex)
    {
      this.dsb.log('error', 'constructor', 'Error instantiating hooks, parts and or helpers...', ex);
    }

  }

  set debug(newValue)
  {
    this.setAttribute('debug', newValue);
    if (this.dsb.helpers.has('tools', 'setLoggingMode'))
    {
      this.dsb.helpers.run('tools', 'setLoggingMode', [newValue]);
    }
  }

  set data(newValue)
  {
    this.setAttribute('data', newValue);
    this._data = false;
  }

  get data()
  {
    return this._data;
  }

  _refreshContext()
  {
    let alias = this.getAttribute('alias');
    if (alias.length > 0)
    {
      this.context_name = '[' + this.getAttribute('alias') + ']' + this._context_name;
    } else

    {
      this.context_name = this._context_name;
    }
  }

  async _getProcessedData()
  {
    if (typeof this._data !== 'object')
    {
      this._data = this.getAttribute('data');

      if (typeof this._data !== 'object')
      {
        try
        {
          this._data = JSON.parse(this._data);
        }
        catch (ex)
        {
          try
          {
            this._data = JSON.parse(atob(this._data));
          }
          catch (ex)
          {
            // Ok data is just data
          }
        }
      }

      if (this._data == null)
      {
        this._data = this.getAttribute('data');
      }
      if (this.dsb.hooks.has('pre_process_data'))
      {
        await this.dsb.hooks.run('pre_process_data', this._data);
      }
      if (typeof this._data === 'string')
      {
        if (this._data.startsWith('helper://'))
        {
          this._data = await this.dsb.helpers.runUrlAsync(this._data, false);
          if (typeof this._data === 'object' && this._data !== null && 'data' in this._data)
          {
            this._data = this._data.data;
          }
        } else
        if ((this._data.startsWith('http://') || this._data.startsWith('https://')) && this.dsb.helpers.has('fetch', 'get'))
        {
          this._data = await this.dsb.helpers.run('fetch', 'get', [this._data]);
        } else
        if (this._data.startsWith('#') && this.dsb.helpers.has('process', 'comment'))
        {
          let comment_data = await this.dsb.helpers.run('process', 'comment', [this.dsb.element, 'data']);
          this.dsb.log('debug', '_getProcessedData', 'Checking for comment data...', comment_data);
          if (comment_data !== null && typeof comment_data === 'object')
          {
            let hash = '';
            if (this.dsb.helpers.has('process', 'hash'))
            {
              hash = this.dsb.helpers.run('process', 'hash', [this._data, {}, 'object']);
            }
            this.dsb.log('debug', '_getProcessedData', 'Found comment data, checking hash...', hash);
            if (this.dsb.helpers.has('process', 'data'))
            {
              comment_data = this.dsb.helpers.run('process', 'data', [comment_data, hash, 'ommit']);
            }
          }
          this._data = comment_data;
        } else

        {
          /// ummm... ok
          this._data = {};
        }
      }
      if (this.dsb.hooks.has('post_process_data'))
      {
        await this.dsb.hooks.run('post_process_data', this._data);
      }
      if (typeof this._data !== 'object')
      {
        this._data = {};
      }
    }
    this.dsb.log('debug', '_getProcessedData', 'Processed data...', this._data);
    return this._data;
  }

  set settings(newValue)
  {
    this.setAttribute('settings', newValue);
    this._settings = false;
  }

  get settings()
  {
    return this._settings;
  }

  async _getProcessedSettings()
  {
    let _this = this;
    if (!(typeof this._settings === 'object'))
    {
      let settings = this.getAttribute('settings');
      if (typeof settings !== 'object')
      {
        try
        {
          settings = JSON.parse(settings);
        }
        catch (ex)
        {
          try
          {
            settings = JSON.parse(atob(settings));
          }
          catch (ex)
          {
            settings = null;
          }
        }
      }

      if (settings == null)
      {
        settings = {};
      }

      if ('helpers' in settings)
      {
        let helpers_type = typeof settings.helpers;
        let new_helper = {};
        switch (helpers_type) {

          case "function":
            new_helper = settings.helpers();
            break;
          case "object":
            new_helper = settings.helpers;
            break;
          case "string":
            let _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : null;
            let wait_count = 'helper_wait_count' in settings ? settings.helper_wait_count : 20;
            let check_for_hepler = function (sec)
            {
              if (_global != null && typeof _global === 'object' && settings.helpers in _global)
              {
                new_helper = _global[settings.helpers];
                _this.dsb.log('debug', 'settings', 'Found helper "' + settings.helpers + '"');
              } else

              {
                if (wait_count > 0)
                {
                  wait_count--;
                  _this.dsb.log('debug', 'settings', 'Cannot find global object for helper "' + settings.helpers + '"... waiting ' + sec + 's and checking again, ' + wait_count + ' more times... ');
                  setTimeout(function () {
                    check_for_hepler(sec);
                  }, sec * 1000);
                } else

                {
                  _this.dsb.log('error', 'settings', 'Cannot find global object for helper "' + settings.helpers + '"... timedout after ' + sec + 's x ' + ('helper_wait_count' in settings ? settings.helper_wait_count : 20) + ' times and checking again... ');
                }
              }
            };
            check_for_hepler('helper_wait' in settings ? settings.helper_wait : 2);
            break;
          default:
            this.dsb.log('warning', 'settings', 'Unknown helpers type "' + helpers_type + '"');
            break;}

        try
        {
          if (typeof new_helper === 'object')
          {
            if ('createContext' in new_helper && typeof new_helper.createContext === 'function')
            {
              new_helper = new_helper.createContext(this.context_name);
            } else

            {
              this.dsb.log('warning', 'settings', 'No helper.createContext found!');
            }
            for (let required_function in this.dsb.helpers)
            {
              if (!(required_function in new_helper) || typeof new_helper[required_function] !== 'function')
              {
                throw 'Missing required function "' + required_function + '"';
              }
            }
            this.dsb.helpers = new_helper;
          } else

          {
            throw 'Not an object';
          }
        }
        catch (ex)
        {
          this.dsb.log('error', 'settings', 'settings.helpers "' + settings.helpers + '" is not a valid helper: ' + ex, { new_helper });
        }

      }
      this._settings = settings;
    }
    this.dsb.log('debug', '_getProcessedSettings', 'Processed settings...', this._settings);
    return this._settings;
  }

  connectedCallback() {
    try
    {
      return this._pre_render();
    }
    catch (ex)
    {
      this.dsb.hooks.run('onFatalError', [500, this, ex]);
    }
  }

  async _pre_render()
  {
    try
    {
      await this._getProcessedSettings();
      await this._getProcessedData();
      this.dsb.log('debug', '_pre_render', 'Preparing to render (__render)');
      return await this._render();
    }
    catch (ex)
    {
      this.dsb.hooks.run('onFatalError', [500, this, ex]);
      this.dsb.log('error', '_pre_render', 'FatalError', ex);
    }
  }

  async _render()
  {
    this.dsb.log('warning', '_render', 'Your suppose to override _render in your class.... async _render(){...}');
  }}



export default HTMLDsbElement;